export default {
  "pl": {
    "question_list": {
      "actions": {
        "cancel": "Cofnij",
        "delete": "Usuń",
        "deleteMultipleQuestionLists": "Usuń…",
        "delete_cancel": "Anuluj",
        "edit": "Edytuj",
        "new": "Nowa lista FAQ",
        "save": "Zapisz",
        "submit": "Utwórz",
        "tickBoxesDeletion": "Zaznacz pola wyboru przy FAQ, które chcesz usunąć. Następnie zatwierdź lub anuluj usuwanie, używając przycisku powyżej."
      },
      "attributes": {
        "description": "Opis",
        "name": "Nazwa",
        "question_list": "FAQ"
      },
      "labels": {
        "allUnits": "Wszystkie jednostki",
        "descriptionOptional": "Opis (opcjonalnie)",
        "editFAQ": "Edytuj FAQ",
        "info": "Masz pytanie o swój dom? Już wkrótce: odpowiedzi na najczęściej zadawane pytania!",
        "questions": " Brak pytań | 1 pytanie | Liczba pytań: {count}",
        "showQuestionListFor": "Pokaż FAQ dotyczące:",
        "title": "Najczęściej zadawane pytania"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Znajdziesz tutaj odpowiedzi na pytania ogólne lub zadane przez inne osoby.",
            "title": "Najczęściej zadawane pytania"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Odpowiedz na pytania ogólne, które mogą mieć twoi klienci.",
            "title": "Utwórz swoją pierwszą listę FAQ"
          }
        }
      },
      "toasts": {
        "create": "Utworzono listę FAQ",
        "delete": "Usunięto listę FAQ",
        "update": "Zaktualizowano listę FAQ"
      },
      "validation": {
        "needName": "Należy podać tytuł",
        "selectQuestionList": "Wybierz przynajmniej 1 FAQ"
      }
    }
  }
}
